import { Fragment } from "react";
import Select from "react-select";

const ProductDescription = ({
  tabNumber,
  prescription,
  handleChangeNumberOfPacks,
  displayedOrderCyclesValue,
  DropdownIndicator,
  prepopulatedOrderCycle,
  reorderCycle,
}) => {
  const numberOfPacks = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 2,
      label: "2",
    },
  ];
  const has_cycle_5 =
    !!prescription.capsule_cycle_5 || !!prescription.capsule_cycle_other_5;
  const has_cycle_10 =
    !!prescription.capsule_cycle_10 || !!prescription.capsule_cycle_other_10;
  const has_cycle_15 =
    !!prescription.capsule_cycle_15 || !!prescription.capsule_cycle_other_15;
  const has_cycle_20 =
    !!prescription.capsule_cycle_20 || !!prescription.capsule_cycle_other_20;
  const has_cycle_25 =
    !!prescription.capsule_cycle_25 || !!prescription.capsule_cycle_other_25;

  return (
    <Fragment>
      {has_cycle_5 && (
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            <input value="5mg" disabled />
          </div>

          <div className="col-md-3 prescriber-details-inputs gray">
            <input
              value={
                prescription.capsule_cycle_5 ||
                prescription.capsule_cycle_other_5 ||
                ""
              }
              disabled
            />
          </div>
          <Fragment>
            <div className="col-md-3 prescriber-details-inputs mt-5-minus gray">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={displayedOrderCyclesValue(
                  tabNumber,
                  "capsule_cycle_5_packs"
                )}
                onChange={(selectedOption) => {
                  handleChangeNumberOfPacks(
                    selectedOption,
                    "capsule_cycle_5_packs",
                    tabNumber
                  );
                }}
                options={numberOfPacks}
                placeholder="Select"
                isDisabled={
                  prepopulatedOrderCycle[tabNumber]
                    ? !reorderCycle[tabNumber]
                    : false
                }
              />
            </div>
          </Fragment>
        </div>
      )}
      {has_cycle_10 && (
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            <input value="10mg" disabled />
          </div>

          <div className="col-md-3 prescriber-details-inputs gray">
            <input
              value={
                prescription.capsule_cycle_10 ||
                prescription.capsule_cycle_other_10 ||
                ""
              }
              disabled
            />
          </div>
          <Fragment>
            <div className="col-md-3 prescriber-details-inputs mt-5-minus gray">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={displayedOrderCyclesValue(
                  tabNumber,
                  "capsule_cycle_10_packs"
                )}
                onChange={(selectedOption) => {
                  handleChangeNumberOfPacks(
                    selectedOption,
                    "capsule_cycle_10_packs",
                    tabNumber
                  );
                }}
                options={numberOfPacks}
                placeholder="Select"
                isDisabled={
                  prepopulatedOrderCycle[tabNumber]
                    ? !reorderCycle[tabNumber]
                    : false
                }
              />
            </div>
          </Fragment>
        </div>
      )}
      {has_cycle_15 && (
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            <input value="15mg" disabled />
          </div>

          <div className="col-md-3 prescriber-details-inputs gray">
            <input
              value={
                prescription.capsule_cycle_15 ||
                prescription.capsule_cycle_other_15 ||
                ""
              }
              disabled
            />
          </div>
          <Fragment>
            <div className="col-md-3 prescriber-details-inputs mt-5-minus gray">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={displayedOrderCyclesValue(
                  tabNumber,
                  "capsule_cycle_15_packs"
                )}
                onChange={(selectedOption) => {
                  handleChangeNumberOfPacks(
                    selectedOption,
                    "capsule_cycle_15_packs",
                    tabNumber
                  );
                }}
                options={numberOfPacks}
                placeholder="Select"
                isDisabled={
                  prepopulatedOrderCycle[tabNumber]
                    ? !reorderCycle[tabNumber]
                    : false
                }
              />
            </div>
          </Fragment>
        </div>
      )}
      {has_cycle_20 && (
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            <input value="20mg" disabled />
          </div>

          <div className="col-md-3 prescriber-details-inputs gray">
            <input
              value={
                prescription.capsule_cycle_20 ||
                prescription.capsule_cycle_other_20 ||
                ""
              }
              disabled
            />
          </div>
          <Fragment>
            <div className="col-md-3 prescriber-details-inputs mt-5-minus gray">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={displayedOrderCyclesValue(
                  tabNumber,
                  "capsule_cycle_20_packs"
                )}
                onChange={(selectedOption) => {
                  handleChangeNumberOfPacks(
                    selectedOption,
                    "capsule_cycle_20_packs",
                    tabNumber
                  );
                }}
                options={numberOfPacks}
                placeholder="Select"
                isDisabled={
                  prepopulatedOrderCycle[tabNumber]
                    ? !reorderCycle[tabNumber]
                    : false
                }
              />
            </div>
          </Fragment>
        </div>
      )}
      {has_cycle_25 && (
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            <input value="25mg" disabled />
          </div>

          <div className="col-md-3 prescriber-details-inputs gray">
            <input
              value={
                prescription.capsule_cycle_25 ||
                prescription.capsule_cycle_other_25 ||
                ""
              }
              disabled
            />
          </div>
          <Fragment>
            <div className="col-md-3 prescriber-details-inputs mt-5-minus gray">
              <Select
                classNamePrefix="custom-select"
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                value={displayedOrderCyclesValue(
                  tabNumber,
                  "capsule_cycle_25_packs"
                )}
                onChange={(selectedOption) => {
                  handleChangeNumberOfPacks(
                    selectedOption,
                    "capsule_cycle_25_packs",
                    tabNumber
                  );
                }}
                options={numberOfPacks}
                placeholder="Select"
                isDisabled={
                  prepopulatedOrderCycle[tabNumber]
                    ? !reorderCycle[tabNumber]
                    : false
                }
              />
            </div>
          </Fragment>
        </div>
      )}
    </Fragment>
  );
};

export default ProductDescription;
